export default __webpack_public_path__ + "static/media/istillparty.e085d8c7.png";